import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Graph = (props: IIcon) => {
  const { className = '', ...rest } = props;
  return (
    <svg
      {...rest}
      className={classNames(className)}
      xmlns="http://www.w3.org/2000/svg"
      width={61}
      height={60}
      viewBox="0 0 61 60"
      fill="none"
    >
      <path
        d="M60.5 30C60.5 13.4315 47.0685 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 46.5685 13.9315 60 30.5 60C47.0685 60 60.5 46.5685 60.5 30Z"
        fill="#FFF7F2"
      />
      <path
        d="M39.3887 30V38.8892"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.5 32.9668V38.8885"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6094 35.5557V38.889"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 31.7773V38.889"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8778 26.121C35.1496 26.3929 35.3347 26.7393 35.4096 27.1164C35.4846 27.4936 35.446 27.8844 35.2989 28.2396C35.1517 28.5948 34.9025 28.8984 34.5828 29.112C34.2631 29.3256 33.8872 29.4396 33.5028 29.4396C33.1183 29.4396 32.7424 29.3256 32.4227 29.112C32.103 28.8984 31.8538 28.5948 31.7067 28.2396C31.5595 27.8844 31.5209 27.4936 31.5959 27.1164C31.6708 26.7393 31.8559 26.3929 32.1278 26.121C32.3083 25.9404 32.5227 25.7971 32.7586 25.6994C32.9945 25.6016 33.2474 25.5513 33.5028 25.5513C33.7581 25.5513 34.011 25.6016 34.2469 25.6994C34.4829 25.7971 34.6972 25.9404 34.8778 26.121Z"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.8817 21.1176C41.1535 21.3895 41.3386 21.7359 41.4135 22.113C41.4885 22.4901 41.4499 22.881 41.3028 23.2362C41.1556 23.5914 40.9064 23.895 40.5867 24.1086C40.267 24.3222 39.8912 24.4362 39.5067 24.4362C39.1222 24.4362 38.7463 24.3222 38.4266 24.1086C38.1069 23.895 37.8577 23.5914 37.7106 23.2362C37.5634 22.881 37.5248 22.4901 37.5998 22.113C37.6748 21.7359 37.8598 21.3895 38.1317 21.1176C38.3122 20.937 38.5266 20.7937 38.7625 20.6959C38.9984 20.5982 39.2513 20.5479 39.5067 20.5479C39.762 20.5479 40.0149 20.5982 40.2508 20.6959C40.4868 20.7937 40.7011 20.937 40.8817 21.1176Z"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.868 27.114C23.1398 27.3859 23.3249 27.7323 23.3999 28.1094C23.4748 28.4866 23.4363 28.8774 23.2891 29.2326C23.1419 29.5879 22.8927 29.8914 22.573 30.105C22.2533 30.3186 21.8775 30.4326 21.493 30.4326C21.1085 30.4326 20.7327 30.3186 20.413 30.105C20.0933 29.8914 19.8441 29.5879 19.6969 29.2326C19.5497 28.8774 19.5112 28.4866 19.5861 28.1094C19.6611 27.7323 19.8462 27.3859 20.118 27.114C20.2985 26.9333 20.5128 26.7899 20.7488 26.6921C20.9847 26.5943 21.2376 26.5439 21.493 26.5439C21.7484 26.5439 22.0013 26.5943 22.2372 26.6921C22.4732 26.7899 22.6875 26.9333 22.868 27.114Z"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8738 22.1118C29.1457 22.3838 29.3308 22.7302 29.4057 23.1073C29.4807 23.4844 29.4421 23.8753 29.295 24.2305C29.1478 24.5857 28.8986 24.8893 28.5789 25.1029C28.2592 25.3165 27.8833 25.4305 27.4989 25.4305C27.1144 25.4305 26.7385 25.3165 26.4188 25.1029C26.0991 24.8893 25.8499 24.5857 25.7028 24.2305C25.5556 23.8753 25.517 23.4844 25.592 23.1073C25.6669 22.7302 25.852 22.3838 26.1238 22.1118C26.4886 21.7473 26.9832 21.5425 27.4989 21.5425C28.0145 21.5425 28.5091 21.7473 28.8738 22.1118Z"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0216 23.7334L34.9883 26.2559"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.876 26.4227L29.1094 24.5669"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9883 27.2559L26.01 24.7334"
        stroke="#FFBC8B"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Graph;
